export default {
  title: "dark",
  colors: {
    primary: "#1b1f38",
    secondary: "#252a48",
    tertiary: "#313862",
    white: "#FFF",
    black: "#000",
    gray: "#BFBFBF",
    success: "#4E41F0",
    info: "#F7931B",
    warning: "#E44C4E",
  },
};
